import { Component, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    AnnualReportBusinessModel,
    AnnualReportProvider,
    SortingItemsHelper,
    onUpdateAnnualReportFailed,
    onUpdateAnnualReportSuccessfully
} from '@modeso/aumico-lib-annualreport-fe';
import {
    AumicoCoreLayoutProvider,
    DateLocalePipe,
    EMPTY_ARRAY_LENGTH,
    FIRST_ELEMENT_INDEX,
    ModalComponent,
    ModalData,
    ModalTitleIcons,
    OkCancelDialogActions,
} from '@modeso/aumico-lib-core-fe';
import { SettingsProvider } from '@modeso/aumico-lib-settings-fe';
import {
    AccountMappingTemplateStatus,
    IAccountMappingDataMapped,
    IAccountMappingFormInput,
    IUpdateAccount,
    TemplatesProvider,
    TemplatesTranslationResponse,
    getTemplateById,
    getTemplatesTargetTranslations,
    isFli,
    isGroup,
    onGetTemplateByLegalFormAndAccountBasisFailed
} from '@modeso/aumico-lib-templates-fe';
import { GetOrganizationDto, OrganizationProvider, OrganizationSettings } from '@modeso/aumico-lib-users-fe';
import {
    AnnualReportStep,
    FinancialStatementTypes,
    IAccount,
    IAccountMappingTemplate,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    IAnnualReport,
    IBalanceSwitchAccount,
    IFinStatements,
    IFinancialLineItemComponent,
    IFinancialStatementSource,
    IGeneralInformation,
    IReclassesAccounts,
    IReclassificationTransaction,
    ITemplateAndAccountsMapping,
    ITranslations,
    ItemType,
    ReclassificationPeriod,
} from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import {
    IAccountingBasisDTO,
    IFinancialLineItemExtendedDTO,
    ILegalFormDTO,
} from '@modeso/types__aumico-lib-settings-be';
import { IGroupEntityDTO, ITemplateEntityDTO, TemplateType } from '@modeso/types__aumico-lib-templates-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import Debug from 'debug';
import fastDeepEqual from 'fast-deep-equal';
import { cloneDeep, omit } from 'lodash-es';
import { Observable, combineLatest, of } from 'rxjs';
import { debounceTime, filter, find, map, mergeMap, take, tap, withLatestFrom } from 'rxjs/operators';
import { TAXONAMY } from '../../../../../../../aumico-lib-annualreport-fe/src/lib/constants/autofill-options';
import { TaxonomyDefinitions } from '../../../../../../../aumico-lib-annualreport-fe/src/lib/helpers/datev.excel.helper';
import { Constants } from '../../../../../../../aumico-lib-core-fe/src/lib/constants/constants';
import { MixpanelService } from '../../../../../../../mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '../../../../../../../mixpanel/mixpanelEvents.enum';
import { environment } from '../../../../../environments/environment';
import { EqualityChecksResult } from '../../../../enums/equality-checks-results.enum';
import { Paths } from '../../../../enums/paths.enum';
import { ConsistencyCheckResult } from '../../../../interfaces/consistency-check-result';
import { ShouldNotProceedResult } from '../../../../interfaces/should-not-proceed-result';
import { DataState } from '../../../../shared/enum/datastate.enum';
import { AppStateDispatcher } from '../../../../state/app.state.dispatcher';
import { FinancialStatementSourceMap } from '../../../../types/financial-statement-source-map.type';
import { localizationKeys } from '../../../../utils/localizationKeys';
import { AnnualReportSubPage } from '../../annual-report-sub-page';
import { EqualityChecksHelper } from '../../helpers/equality-checks.helper';
import { hasLegacyReclasses, isReclassNewWorld, legacyReclassesAutofillWarningSeenKey } from '../../helpers/newReclassesGate.helper';
import { TranslationMapper } from '../../mappers/translation.mapper';
import { ImportService } from '../../services/import.service';
import { templateConstants } from './../../../../shared/template-constants';
import { FinancialStatementAccountMappingFormHelper } from './../../helpers/financial-statement-account-mapping-form.helper';
const debug = Debug('aumico:saas:FinancialStatementAccountMappingFormComponent');

const EMPTY_GROUP_WARNING_LOCALIZATION_KEY = 'aumico_templates_group_account_mapping_there_is_an_empty_group_warning';
@UntilDestroy()
@Component({
    selector: 'aumico-financial-statement-account-mapping-form-component',
    templateUrl: 'financial-statement-account-mapping-form.component.html',
    styleUrls: ['financial-statement-account-mapping-form.component.scss'],
})
export class FinancialStatementAccountMappingFormComponent extends AnnualReportSubPage implements OnInit {
    private legalForm: ILegalFormDTO;
    private accountingBasis: IAccountingBasisDTO;
    financialStatementSource: FinancialStatementSourceMap = {} as FinancialStatementSourceMap;
    private _balanceAccounts: IAccount[] = [];
    autofillGroupingMasking: any;
    /** Saved translations carried over from the autofill source(s), balance + income merged per language. */
    autofillTranslations: ITranslations | null = null;
    deleteSwitchAccount: boolean;
    copiedFinStatements: IFinStatements[];

    public get balanceAccounts(): IAccount[] {
        return this._balanceAccounts;
    }
    public set balanceAccounts(value: IAccount[]) {
        this._balanceAccounts = value;
        this.updateData();
    }
    private _incomeAccounts: IAccount[] = [];
    public get incomeAccounts(): IAccount[] {
        return this._incomeAccounts;
    }
    public set incomeAccounts(value: IAccount[]) {
        this._incomeAccounts = value;
        this.updateData();
    }

    balanceSwitchAccounts: IBalanceSwitchAccount[] = [];
    private fileChanged: boolean;

    activeAnnualReport: IAnnualReport | undefined;
    activeFinStatements: IFinStatements[] = [];
    businessModel = AnnualReportBusinessModel.OR;
    accountMappingInput: IAccountMappingFormInput = {} as IAccountMappingFormInput;
    private balanceFinancialStatementMapping: IAccountMappingDataMapped | undefined;
    private incomeFinancialStatementMapping: IAccountMappingDataMapped | undefined;
    rawIncomeTemplate: ITemplateEntityDTO | undefined;
    rawBalanceTemplate: ITemplateEntityDTO | undefined;
    balanceIndexInFinStatementsArray = 0;
    incomeIndexInFinStatementsArray = 1;
    isPreviousYearDataTakenFromPreviousBalanceAnnualReport: boolean;
    isPreviousYearDataTakenFromPreviousIncomeAnnualReport: boolean;

    // Takes value from the autofill annual report's income statement closing balance
    previousYearClosingIncomeFromAutofillReport: number | undefined;
    // Value is fetched from the backend corresponding the balance sheet date
    previousAnnualProfitForMissingIncomePeriod: number | undefined;

    shouldUsePreviousAnnualProfitFromCurrentIncomeStatement = false;

    templatesTranslations$: Observable<TemplatesTranslationResponse>;
    get isMappingInputReady(): boolean {
        const accountMappingInputKeys = Object.keys(this.accountMappingInput);
        return (
            accountMappingInputKeys.includes('balance') &&
            accountMappingInputKeys.includes('income') &&
            accountMappingInputKeys.includes('sheetSystem') &&
            accountMappingInputKeys.includes('dates')
        );
    }

    isSavedMode = false;
    currency: string;
    private noPreviousDatePlaceholder = '-';

    isIncomeInitialValue = true;
    isBalanceInitialValue = true;
    incomeDefaultMapping: IAccountMappingDataMapped;
    balanceDefaultMapping: IAccountMappingDataMapped;
    readonly defaultLanguage = environment.defaultLanguage;
    readonly debuggingFeaturesEnabled = environment.debuggingFeaturesEnabled;
    openWipeSwitchAccountDialog = false;
    profitOfTheYearFliName: string | undefined;
    annualSurplusFliName: string | null;
    uncoveredShortfallAssetsFliName: string | undefined;
    uncoveredShortfallLiabilitiesFliName: string | undefined;

    private defaultTemplatesGroups: Map<string, IGroupEntityDTO> | undefined;

    readonly uploadStepLabel = Constants.ACTION_BAR.LABELS.UPLOAD_BALANCE_SHEET_KEY;
    readonly uploadStepPath = Paths.UPLOAD;
    localizationKeys = localizationKeys;
    readonly financialStatementMinimumLength = templateConstants.financialStatementMinimumLength;
    private isSaveRequestInProgress = false;

    isPartOfArNavigation$: Observable<boolean>;

    DataState = DataState;
    dataState: DataState = DataState.Loading;
    templateNotFoundError = false;
    dataIncompleteError = false;

    applyUncoveredShortfall = false;

    private organizationSettings: OrganizationSettings | undefined;

    public cashAndCashFli: string | undefined;

    isCashFlowTypeForFliUsed = true;
    currentLanguage = this.getCurrentLanguageWithFallBack();
    public allFinancialLineItems: IFinancialLineItemExtendedDTO[] = [];

    public previousYearBalanceTemplate: IAccountMappingTemplate | undefined;
    public previousYearIncomeTemplate: IAccountMappingTemplate | undefined;
    /** REV-22122: the previous year's DATEV taxonomy — places accounts that are new this year. */
    public previousYearImportedTaxonomy: IAnnualReport['importedTaxonomy'] | undefined;


    private isGetAnnualReportForUploadAndMappingAutoFill = false;
    enforceOverwrite: boolean = false;

    public supportOperation = false;
    showSwitchToAutomaticTransferOfAnnualResultBanner = false;
    showSwitchToAutomaticTransferConfirmationModal = false;
    isAutomaticTransferOfAnnualResultEnabled: boolean;
    applyAutomaticTransferOfAnnualResultForCurrentAndPreviousValues: boolean;

    constructor(
        private readonly templatesProvider: TemplatesProvider,
        private readonly settingsProvider: SettingsProvider,
        private readonly appStateDispatcher: AppStateDispatcher,
        private readonly annualReportProvider: AnnualReportProvider,
        private readonly organizationProvider: OrganizationProvider,
        private dateLocalPipe: DateLocalePipe,
        public injector: Injector,
        public override aumicoCoreLayoutProvider: AumicoCoreLayoutProvider,
        protected override actionsListener$: ActionsSubject,
        private readonly mixpanelService: MixpanelService,
        private readonly importService: ImportService,
        dialog: MatDialog,
    ) {
        super(injector, actionsListener$, aumicoCoreLayoutProvider, dialog);

        this.currentAnnualReportStep = AnnualReportStep.IMPORT_BALANCE_INCOME;

        this.isPartOfArNavigation$ = this.annualReportNavigationProvider.isPartOfArNavigation$(
            AnnualReportStep.IMPORT_BALANCE_INCOME,
        );

        this.appStateDispatcher
            .getSupportOperation()
            .pipe(untilDestroyed(this))
            .subscribe((supportOperation) => {
                this.supportOperation = supportOperation;
            });
    }
    override ngOnInit(): void {
        if (this.importService.getEnforceOverwriteStructure()) {
            this.enforceOverwrite = true;
            this.importService.reset();
        }
        if (this.enforceOverwrite) {
            this.showReplaceTaxonomyDialog();
        } else {
            this.finalizeInitialization();
        }
    }

    private showReplaceTaxonomyDialog(): void {
        const dialogRef = this.dialog.open<ModalComponent, ModalData, OkCancelDialogActions>(ModalComponent, {
            disableClose: false,
            panelClass: 'custom-modalbox',
            data: {
                showCloseButton: true,
                titleIcon: ModalTitleIcons.WARNING,
                footerButtons: [
                    {
                        localizationKey: 'aumico_reports_annualreport_import_structure_dialog_action_button',
                        action: OkCancelDialogActions.OK,
                        buttonColor: 'primary',
                    },
                    {
                        localizationKey: 'aumico_annual_report_cancel_button',
                        action: OkCancelDialogActions.CANCEL,
                        buttonColor: 'basic',
                    },
                ],
                titleLocalizationKey: 'aumico_reports_annualreport_import_structure_dialog_title',
                content: {
                    text: ['aumico_reports_annualreport_import_structure_dialog_text'],
                    icon: 'aumico-pattern-xls-file-icon-purple',
                },
            },
        });

        dialogRef
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                if (result !== OkCancelDialogActions.OK) {
                    this.enforceOverwrite = false;
                }
                this.finalizeInitialization();
            });
    }

    private finalizeInitialization(): void {
        this.mixpanelService.time_event(MIXPANEL_EVENTS.ACCOUNT_MAPPING_TIME_SPENT_TILL_COMPLETION);
        this.settingsProvider.dispatchGetAllFinancialLineItem();
        this.annualReportProvider.resetActiveAnnualReport();

        // REV-XXXXX: fire the legacy-reclasses-from-autofill warning when
        // both the current AR and the autofill source are loaded.
        this.maybeShowLegacyReclassesAutofillWarning();

        this.annualReportProvider
            .getActiveAnnualReportEncryptedId$()
            .pipe(
                find((activeAnnualReportEncryptedId) => activeAnnualReportEncryptedId != null),
                untilDestroyed(this),
            )
            .subscribe((activeAnnualReportEncryptedId) => {
                this.activeAnnualReportEncryptedId = activeAnnualReportEncryptedId;
                this.annualReportProvider.dispatchActiveAnnualReport(this.activeAnnualReportEncryptedId);
            });

        super.ngOnInit();

        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                filter((organization: GetOrganizationDto) => organization != null),
                tap((organization) => {
                    if (organization.settings != null) {
                        this.organizationSettings = organization.settings;
                    }
                }),
                tap(() => {
                    // TODO selectAnnualReportForBalanceAutoFill
                    this.annualReportProvider
                        .getAnnualReportForBalanceAutoFill$()
                        .pipe(
                            filter((report) => report != null),
                            untilDestroyed(this),
                        )
                        .subscribe((previousAnnualReportForBalance) => {
                            if (
                                previousAnnualReportForBalance.finStatements?.[this.balanceIndexInFinStatementsArray]
                                    ?.templateAndAccountsMapping?.template
                            ) {
                                this.previousYearBalanceTemplate =
                                    previousAnnualReportForBalance.finStatements[
                                        this.balanceIndexInFinStatementsArray
                                    ].templateAndAccountsMapping.template;
                            }
                            if (previousAnnualReportForBalance.groupingAndMasking != null) {
                                this.autofillGroupingMasking = previousAnnualReportForBalance.groupingAndMasking;
                            }
                            this.mergeAutofillTranslations(previousAnnualReportForBalance.translations);
                            // REV-22122: the taxonomy the previous year was imported with — DATEV or
                            // the aumico format, null without an import. The lib uses only a DATEV
                            // plan as fallback (`fallbackPlanFor`) — see the
                            // `previousYearImportedTaxonomy` input.
                            this.previousYearImportedTaxonomy =
                                previousAnnualReportForBalance.importedTaxonomy ?? undefined;
                        });
                    // TODO selectAnnualReportForIncomeAutoFill
                    this.annualReportProvider
                        .getAnnualReportForIncomeAutoFill$()
                        .pipe(
                            filter((report) => report != null),
                            untilDestroyed(this),
                        )
                        .subscribe((previousAnnualReportForIncome) => {
                            if (
                                previousAnnualReportForIncome.finStatements?.[this.incomeIndexInFinStatementsArray]
                                    ?.templateAndAccountsMapping?.template
                            ) {
                                this.previousYearIncomeTemplate =
                                    previousAnnualReportForIncome.finStatements[
                                        this.incomeIndexInFinStatementsArray
                                    ].templateAndAccountsMapping.template;
                            }
                            // REV-21132: Also set autofillGroupingMasking from income autofill source
                            // so reclassifications are available even in combined autofill scenarios
                            if (previousAnnualReportForIncome.groupingAndMasking != null) {
                                this.autofillGroupingMasking = previousAnnualReportForIncome.groupingAndMasking;
                            }
                            this.mergeAutofillTranslations(previousAnnualReportForIncome.translations);
                        });
                }),
                mergeMap(() =>
                    this.annualReportProvider.getActiveAnnualReport$().pipe(
                        filter((activeAnnual: IAnnualReport) => activeAnnual != null),
                        tap((activeAnnualReport) => {
                            if (activeAnnualReport.generalInformation == null) {
                                this.dataState = DataState.Error;
                                this.dataIncompleteError = true;
                            }
                            if (
                                FinancialStatementAccountMappingFormHelper.isTemplateMappingDefined(
                                    activeAnnualReport.finStatements,
                                    templateConstants.balanceTemplate,
                                    templateConstants.incomeTemplate,
                                )
                            ) {
                                this.isSavedMode = true;
                            }
                        }),
                        filter((activeAnnual: IAnnualReport) => activeAnnual.generalInformation != null),
                        untilDestroyed(this),
                    ),
                ),
                mergeMap((annualReport) => {
                    return this.settingsProvider.allFinancialLineItem$().pipe(
                        filter(
                            (financialLineItems) =>
                                financialLineItems != null && financialLineItems.length !== EMPTY_ARRAY_LENGTH,
                        ),
                        map((financialLineItems) => ({ annualReport, financialLineItems })),
                        take(1),
                    );
                }),
                mergeMap(({ annualReport, financialLineItems }) => {
                    const previousBalanceSheetData = annualReport.generalInformation.balancePreviousYearDate;
                    if (previousBalanceSheetData) {
                        return this.providerOfAnnualReports.getAnnualProfitOfBalanceAutofillFinstatements$(previousBalanceSheetData).pipe(
                            map((previousAnnualProfit) => {
                                this.handlePreviousAnnualProfitResponse(annualReport, previousAnnualProfit);
                                return { annualReport, financialLineItems };
                            })
                        );
                    }
                    return of({ annualReport, financialLineItems });
                }),
                //Always needs to use the latest active original financial statements, NOT the ones that are being edited
                withLatestFrom(this.annualReportProvider.getActiveOriginalFinStatements$()),
                untilDestroyed(this),
            )
            .subscribe(([{ annualReport, financialLineItems }, finStatements]) => {
                this.allFinancialLineItems = financialLineItems;
                if (annualReport.isAutomaticTransferOfAnnualResultEnabled == null) {
                    this.showSwitchToAutomaticTransferOfAnnualResultBanner = true;
                }
                this.handleGetActiveAnnualReport(annualReport, finStatements);
            });

        this.actionsListener$
            .pipe(ofType(onUpdateAnnualReportSuccessfully), debounceTime(500), untilDestroyed(this))
            .subscribe(() => {
                if (this.isSaveRequestInProgress) {
                    this.onSaveSuccessfully();
                }
            });

        this.actionsListener$
            .pipe(ofType(onUpdateAnnualReportFailed), untilDestroyed(this))
            .subscribe(() => this.onSaveFailed());

        this.actionsListener$
            .pipe(ofType(onGetTemplateByLegalFormAndAccountBasisFailed), debounceTime(1000), untilDestroyed(this))
            .subscribe(() => {
                this.dataState = DataState.Error;
                this.templateNotFoundError = true;
            });

        this.appStateDispatcher
            .getUploadedFileChanged()
            .pipe(untilDestroyed(this))
            .subscribe((fileChanged) => {
                this.fileChanged = fileChanged;
            });

        // balance financial statement source, from previous step
        this.annualReportProvider
            .getBalanceFinancialStatementSource$()
            .pipe(
                filter((financialStatementSource: IFinancialStatementSource) => financialStatementSource != null),
                untilDestroyed(this),
            )
            .subscribe((items) => this.handleFinancialStatementSourceResponse(items, true));

        // income financial statement source, from previous step
        this.annualReportProvider
            .getIncomeFinancialStatementSource$()
            .pipe(
                filter((financialStatementSource: IFinancialStatementSource) => financialStatementSource != null),
                untilDestroyed(this),
            )
            .subscribe((items) => this.handleFinancialStatementSourceResponse(items, false));

        this.templatesProvider
            .getTemplateByLegalFormAndAccountBasis$()
            .pipe(
                filter((template: ITemplateEntityDTO) => template != null),
                untilDestroyed(this),
            )
            .subscribe((items) => this.handleTemplateResponse(items));

        this.actionsListener$
            .pipe(ofType(getTemplateById.success), untilDestroyed(this))
            .subscribe((response) => this.handleTemplateResponse(response.payload));

        this.templatesProvider.dispatchGroups();

        this.templatesTranslations$ = this.actionsListener$.pipe(
            ofType(getTemplatesTargetTranslations.success),
            map((action) => action.payload),
        );
    }

    private tryToGetTemplate(): void {
        if (this.legalForm == null || this.accountingBasis == null) {
            throw new Error('legal form or accounting basis are not defined');
        }

        // if no annual report template is used, then we proceed with the normal flow and get the default taxonomies based on LF & AB
        if (this.activeAnnualReport.annualReportTemplate == null) {
            this.dispatchBalanceTemplateBylegalFormAndAccountingBasis();
            this.dispatchIncomeTemplateBylegalFormAndAccountingBasis();
            return;
        }

        //if no balance taxonomy is defined in the ar template, then we fetch the default based on LF & AB
        if (this.activeAnnualReport.annualReportTemplate.balanceTaxonomyId == null) {
            this.dispatchBalanceTemplateBylegalFormAndAccountingBasis();
        } else {
            setTimeout(() => {
                this.templatesProvider.dispatchTemplateById(
                    this.activeAnnualReport.annualReportTemplate.balanceTaxonomyId,
                );
            }, 10); // Delay of 100ms
        }

        //if no income taxonomy is defined in the ar template, then we fetch the default based on LF & AB
        if (this.activeAnnualReport.annualReportTemplate.incomeTaxonomyId == null) {
            this.dispatchIncomeTemplateBylegalFormAndAccountingBasis();
        } else {
            setTimeout(() => {
                this.templatesProvider.dispatchTemplateById(
                    this.activeAnnualReport.annualReportTemplate.incomeTaxonomyId,
                );
            }, 10);
        }
    }

    public onAccountChangedInReport(updatedAccountData: IUpdateAccount): void {
        const accountIndexInAnnualReportIndex = this.getAccountIndex(
            updatedAccountData.oldAccount,
            updatedAccountData.financialStatementTemplateTypeIndex,
        );

        if (accountIndexInAnnualReportIndex > -1) {
            this.activeFinStatements[
                updatedAccountData.financialStatementTemplateTypeIndex
            ].templateAndAccountsMapping.accounts[accountIndexInAnnualReportIndex] = updatedAccountData.updatedAccount;
            this.templatesProvider.updateAccountInExcelAccounts(
                updatedAccountData.updatedAccount,
                updatedAccountData.oldAccount.accountNumber,
            );
        } else {
            this.activeFinStatements[
                updatedAccountData.financialStatementTemplateTypeIndex
            ].templateAndAccountsMapping.accounts.push(updatedAccountData.updatedAccount);
            this.templatesProvider.addAccountToAllAccountsExcel(updatedAccountData.updatedAccount);
        }
    }

    public onFliOrGroupDeleted(deletedItem: IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI): void {
        if (deletedItem == null) {
            return;
        }

        if (isFli(deletedItem)) {
            if (this.activeAnnualReport.equityMovementSchedule != null) {
                this.handleEquityMovementScheduleOnItemDeletion(deletedItem);
            }

            if (this.activeAnnualReport.notes != null) {
                this.handleNotesOnItemDeletion(deletedItem);
            }

            if (this.activeAnnualReport.cashFlowStatement != null) {
                this.handleCashFlowStatementOnItemDeletion(deletedItem);
            }
        } else if (isGroup(deletedItem)) {
            const flis = deletedItem.items.filter(
                (item) => item.type === ItemType.FLI,
            ) as IAccountMappingTemplateGroupItemFLI[];

            flis.forEach((fli) => {
                if (this.activeAnnualReport.equityMovementSchedule != null) {
                    this.handleEquityMovementScheduleOnItemDeletion(fli);
                }

                if (this.activeAnnualReport.notes != null) {
                    this.handleNotesOnItemDeletion(fli);
                }

                if (this.activeAnnualReport.cashFlowStatement != null) {
                    this.handleCashFlowStatementOnItemDeletion(fli);
                }
            });

            deletedItem.groups.forEach((group) => {
                this.onFliOrGroupDeleted(group);
            });
        }
    }

    private handleCashFlowStatementOnItemDeletion(
        deletedItem: IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI,
    ): void {
        const deletedItemIndexInFinancingActivities =
            this.activeAnnualReport.cashFlowStatement.financingActivities.entries.findIndex(
                (entry) => entry.fliId === deletedItem.name,
            );
        const deletedItemIndexInInvestingActivities =
            this.activeAnnualReport.cashFlowStatement.investingActivities.entries.findIndex(
                (entry) => entry.fliId === deletedItem.name,
            );
        const deletedItemIndexInOperatingActivities =
            this.activeAnnualReport.cashFlowStatement.operatingActivities.entries.findIndex(
                (entry) => entry.fliId === deletedItem.name,
            );

        if (deletedItemIndexInFinancingActivities >= EMPTY_ARRAY_LENGTH) {
            this.activeAnnualReport.cashFlowStatement.financingActivities.entries.splice(
                deletedItemIndexInFinancingActivities,
                1,
            );
        }
        if (deletedItemIndexInInvestingActivities >= EMPTY_ARRAY_LENGTH) {
            this.activeAnnualReport.cashFlowStatement.investingActivities.entries.splice(
                deletedItemIndexInInvestingActivities,
                3,
            );
        }
        if (deletedItemIndexInOperatingActivities >= EMPTY_ARRAY_LENGTH) {
            this.activeAnnualReport.cashFlowStatement.operatingActivities.entries.splice(
                deletedItemIndexInOperatingActivities,
                1,
            );
        }
    }

    private handleNotesOnItemDeletion(
        deletedItem: IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI,
    ): void {
        this.activeAnnualReport.notes.accordions.forEach((accordion) => {
            accordion.data.forEach((data) => {
                if (data.componentName === ComponentType.FINANCIAL_LINE_ITEM) {
                    if ((data.data as IFinancialLineItemComponent).flis != null) {
                        (data.data as IFinancialLineItemComponent).flis.forEach((fli, fliIndex) => {
                            if (fli.id === deletedItem.name) {
                                (data.data as IFinancialLineItemComponent).flis.splice(fliIndex, 1);
                            }
                        });
                    }
                }
            });
        });
    }

    private handleEquityMovementScheduleOnItemDeletion(
        deletedItem: IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI,
    ): void {
        if (!isFli(deletedItem) || this.activeAnnualReport.equityMovementSchedule == null) {
            return;
        }

        const deletedItemInEquityMovementEntriesIndex =
            this.activeAnnualReport.equityMovementSchedule.equityMovementEntries.findIndex(
                (item) => item.fliName === deletedItem.name,
            );
        // findIndex yields -1 for an FLI the schedule never held — every FLI outside the equity group.
        // Splicing at -1 would drop the LAST entry instead, which is normally the total-equity column.
        if (deletedItemInEquityMovementEntriesIndex >= EMPTY_ARRAY_LENGTH) {
            this.activeAnnualReport.equityMovementSchedule.equityMovementEntries.splice(
                deletedItemInEquityMovementEntriesIndex,
                1,
            );
        }
    }

    balanceChanged(accountMappingDataMapped: IAccountMappingDataMapped) {
        if (accountMappingDataMapped) {
            // REV-21132: The mapping engine emits a template that drops the
            // template-level `reclassesAccounts` (the reclass "phantom" accounts
            // created in the separate reclassification step) from the FLIs.
            // Restore them from the already-saved mapping so they survive a save
            // and don't register as a phantom unsaved change. Reclasses cannot be
            // edited on this page, so they always come from the saved template.
            this.restoreSavedReclassesAccounts(accountMappingDataMapped, this.balanceIndexInFinStatementsArray);
            // on the function's first call we get the default prepared value for mapping
            if (this.isBalanceInitialValue === true && accountMappingDataMapped.accounts.length !== 0) {
                this.isBalanceInitialValue = false;
                this.balanceDefaultMapping = cloneDeep(accountMappingDataMapped);
            }
            this.balanceFinancialStatementMapping = accountMappingDataMapped;
        }
    }

    specialFliChanged(change: Record<string, string>) {
        if (change && change['profitOfTheYear']) {
            this.profitOfTheYearFliName = change['profitOfTheYear'];
        }
        if (change && change['annualSurplusFliName']) {
            this.annualSurplusFliName = change['annualSurplusFliName'];
        }
        if (change && change['uncoveredShortfallAssetsFli']) {
            this.uncoveredShortfallAssetsFliName = change['uncoveredShortfallAssetsFli'];
        }
        if (change && change['uncoveredShortfallLiabilitiesFli']) {
            this.uncoveredShortfallLiabilitiesFliName = change['uncoveredShortfallLiabilitiesFli'];
        }
    }

    incomeChanged(accountMappingDataMapped: IAccountMappingDataMapped) {
        if (accountMappingDataMapped) {
            // REV-21132: see balanceChanged — restore the engine-dropped
            // template-level reclasses accounts from the saved mapping.
            this.restoreSavedReclassesAccounts(accountMappingDataMapped, this.incomeIndexInFinStatementsArray);
            // on the function's first call we get the default prepared value for mapping
            if (this.isIncomeInitialValue === true && accountMappingDataMapped.accounts.length !== 0) {
                this.isIncomeInitialValue = false;
                this.incomeDefaultMapping = cloneDeep(accountMappingDataMapped);
            }
            this.incomeFinancialStatementMapping = accountMappingDataMapped;
        }
    }

    /**
     * REV-21132: Copies the template-level `reclassesAccounts` from the saved
     * mapping (the original fin statements loaded for this report) into the
     * mapping emitted by the account-mapping engine, matching FLIs and SubFLIs
     * by name. The engine rebuilds its template without these reclass phantom
     * accounts, so without this they would be lost on save and would also show
     * up as a phantom diff in the unsaved-changes check. Only non-empty saved
     * reclasses arrays are copied, so the autofill / new-report flows (which
     * have no saved reclasses yet) are left untouched.
     */
    private restoreSavedReclassesAccounts(mapping: IAccountMappingDataMapped, finStatementIndex: number): void {
        const savedGroup = (
            this.activeFinStatements?.[finStatementIndex]?.templateAndAccountsMapping?.template as IAccountMappingTemplate
        )?.group;
        const targetGroup = (mapping?.template as IAccountMappingTemplate)?.group;
        if (savedGroup == null || targetGroup == null) {
            return;
        }

        const savedFlis = this.collectFliMap(savedGroup);
        const targetFlis = this.collectFliMap(targetGroup);

        for (const [fliName, targetFli] of targetFlis) {
            const savedFli = savedFlis.get(fliName);
            if (!savedFli) {
                continue;
            }

            if (Array.isArray(savedFli.reclassesAccounts) && savedFli.reclassesAccounts.length > 0) {
                targetFli.reclassesAccounts = cloneDeep(savedFli.reclassesAccounts);
            }

            const savedSubMap = this.collectSubFliMap(savedFli);
            const targetSubMap = this.collectSubFliMap(targetFli);
            for (const [subKey, targetSub] of targetSubMap) {
                const savedSub = savedSubMap.get(subKey);
                if (savedSub && Array.isArray(savedSub.reclassesAccounts) && savedSub.reclassesAccounts.length > 0) {
                    targetSub.reclassesAccounts = cloneDeep(savedSub.reclassesAccounts);
                }
            }
        }
    }

    getAnnualReportToBeSaved(): IAnnualReport | undefined {
        if (
            this.activeAnnualReport == null ||
            this.balanceFinancialStatementMapping == null ||
            this.incomeFinancialStatementMapping == null
        ) {
            return undefined;
        }

        let isDataChanged = false;

        if (this.debuggingFeaturesEnabled) {
            isDataChanged = this.detectChangesInAccountMappingData() || this.deleteSwitchAccount;
        } else {
            isDataChanged = this.detectChangesInAccountMappingData();
        }

        // TODO: find out if that makes sense, I believe this doesn't make sense
        // The reason is, because we add grouping masking from previous year already in this step.
        // However, that doesn't make sense that we handle this as a data-change. Instead we should simply save it.
        /*if (isDataChanged === false) {
            if (this.activeAnnualReport.groupingAndMasking == null && this.autofillGroupingMasking != null) {
                isDataChanged = true;
            }
        }*/

        return this.prepareFinancialStatementsForAnnualReportSaving(
            this.activeAnnualReport,
            this.activeFinStatements,
            this.balanceFinancialStatementMapping,
            this.incomeFinancialStatementMapping,
            isDataChanged,
        );
    }

    private dispatchBalanceTemplateBylegalFormAndAccountingBasis(): void {
        this.templatesProvider.dispatchTemplateByLegalFormAndAccountBasis(
            FinancialStatementTypes.BALANCE,
            this.legalForm.name,
            this.accountingBasis.name,
        );
    }

    private dispatchIncomeTemplateBylegalFormAndAccountingBasis(): void {
        this.templatesProvider.dispatchTemplateByLegalFormAndAccountBasis(
            FinancialStatementTypes.INCOME,
            this.legalForm.name,
            this.accountingBasis.name,
        );
    }

    private handleGetActiveAnnualReport(annualReport: IAnnualReport, finStatements: IFinStatements[]): void {
        if (
            finStatements.length >= templateConstants.financialStatementMinimumLength &&
            finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template != null
        ) {
            this.disableProceedButton = false;
            this.footerExtraButtonActions[FIRST_ELEMENT_INDEX].disabled = false;

        }

        this.isAutomaticTransferOfAnnualResultEnabled = annualReport.isAutomaticTransferOfAnnualResultEnabled === true;

        if (annualReport.generalInformation.noPreviousData || (annualReport.generalInformation.balancePreviousYearDate.toString() === annualReport.generalInformation.incomePreviousYearToDate.toString())) {
            //If previous balance sheet date corresponds to the previous income statement period end, then use annual profits from the same current report
            this.shouldUsePreviousAnnualProfitFromCurrentIncomeStatement = true;
        }

        if (annualReport.importedTaxonomy != null) {
            const unreferencedBalanceImportedTaxonomyMainGroup: IAccountMappingTemplateGroup =
                cloneDeep<IAccountMappingTemplateGroup>(annualReport.importedTaxonomy.rawBalanceTemplate.group);

            const unreferencedIncomeImportedTaxonomyMainGroup: IAccountMappingTemplateGroup =
                cloneDeep<IAccountMappingTemplateGroup>(annualReport.importedTaxonomy.rawIncomeTemplate.group);

            // by 'referenced' it is meant that sortedItems are all reference to one another. When changing in a sortedItem in a certain group, it is changed in all groups that contain that same sortedItem
            const referencedBalanceImportedTaxonomyMainGroup =
                SortingItemsHelper.mapGroupSortedItemsToSortedMappingItem(unreferencedBalanceImportedTaxonomyMainGroup);

            const referencedBalanceImportedTaxonomy: IAccountMappingTemplate = cloneDeep<IAccountMappingTemplate>({
                ...annualReport.importedTaxonomy.rawBalanceTemplate,
                group: referencedBalanceImportedTaxonomyMainGroup,
            });

            // by 'referenced' it is meant that sortedItems are all reference to one another. When changing in a sortedItem in a certain group, it is changed in all groups that contain that same sortedItem
            const referencedIncomeImportedTaxonomyMainGroup = SortingItemsHelper.mapGroupSortedItemsToSortedMappingItem(
                unreferencedIncomeImportedTaxonomyMainGroup,
            );

            const referencedIncomeImportedTaxonomy: IAccountMappingTemplate = cloneDeep<IAccountMappingTemplate>({
                ...annualReport.importedTaxonomy.rawIncomeTemplate,
                group: referencedIncomeImportedTaxonomyMainGroup,
            });

            this.accountMappingInput.importedTaxonomyDefinitions = cloneDeep<TaxonomyDefinitions>({
                rawBalanceTemplate: referencedBalanceImportedTaxonomy,
                rawIncomeTemplate: referencedIncomeImportedTaxonomy,
            });
        } else {
            // if no importedTaxonomy then we need admin flis from settings
            this.settingsProvider.dispatchGetAllFinancialLineItem();
        }

        const uploadAndMappingAutoFillAnnualReportId = annualReport.templateReportAutofillOptions?.[TAXONAMY];

        if (uploadAndMappingAutoFillAnnualReportId != null) {
            this.annualReportProvider.dispatchGetAnnualReportForMappingAutoFill(uploadAndMappingAutoFillAnnualReportId);
        }
        this.activeAnnualReport = cloneDeep<IAnnualReport>(annualReport);
        this.activeFinStatements = cloneDeep<IAnnualReport>(finStatements);
        if (annualReport.generalInformation != null) {
            this.dataState = DataState.Success;
            this.dataIncompleteError = false;

            this.accountingBasis = annualReport.generalInformation.accountingBasis;
            this.legalForm = annualReport.generalInformation.company.legalform;
            this.currency = annualReport.generalInformation.currency
                ? annualReport.generalInformation.currency.name
                : '';
            this.isPreviousYearDataTakenFromPreviousBalanceAnnualReport =
                annualReport.generalInformation.isPreviousDataTakenFromPreviousAnnualReport;

            this.isPreviousYearDataTakenFromPreviousIncomeAnnualReport =
                annualReport.generalInformation.isPreviousDataTakenFromPreviousAnnualReportForIncomeStatement;

            this.setDates(annualReport.generalInformation);
        }

        if (this.rawIncomeTemplate == null || this.rawBalanceTemplate == null) {
            this.tryToGetTemplate();
        }

        this.defineSettings();

        if (finStatements.length >= templateConstants.financialStatementMinimumLength) {
            const balanceIndex =
                FinancialStatementAccountMappingFormHelper.getIndexForFinancialStatementSourceFromActiveAnnualReport(
                    this.activeFinStatements,
                    FinancialStatementTypes.BALANCE,
                );
            const incomeIndex =
                FinancialStatementAccountMappingFormHelper.getIndexForFinancialStatementSourceFromActiveAnnualReport(
                    this.activeFinStatements,
                    FinancialStatementTypes.INCOME,
                );

            const extractedAccounts = FinancialStatementAccountMappingFormHelper.extractActiveAnnualReportAccounts(
                this.activeFinStatements,
                balanceIndex,
                incomeIndex,
            );
            this.balanceAccounts =
                extractedAccounts != null
                    ? (extractedAccounts.extractedBalanceAccounts as unknown as IAccount[])
                    : ([] as IAccount[]);
            this.incomeAccounts =
                extractedAccounts != null
                    ? (extractedAccounts.extractedIncomeAccounts as unknown as IAccount[])
                    : ([] as IAccount[]);

            this.balanceSwitchAccounts =
                this.activeFinStatements[balanceIndex].templateAndAccountsMapping.balanceSwitchAccounts;

            if (
                FinancialStatementAccountMappingFormHelper.isTemplateMappingDefined(
                    this.activeFinStatements,
                    balanceIndex,
                    incomeIndex,
                )
            ) {
                this.handleEditMode(annualReport, finStatements, balanceIndex, incomeIndex);
            } else {
                // Todo: replace emptying the mapping with taking the mapping from already saved mapping
                this.accountMappingInput.balance = null;
                this.accountMappingInput.income = null;

                this.onPrerequisiteDataInitialized();
                // Dispatching autofill reports

                if (annualReport.generalInformation.isPreviousDataTakenFromPreviousAnnualReport && annualReport.autoFillAnnualReportId) {
                    this.annualReportProvider.dispatchBalanceAutoFillFromChosenOrSavedId(annualReport.autoFillAnnualReportId);

                }

                if (annualReport.generalInformation.isPreviousDataTakenFromPreviousAnnualReport && annualReport.autoFillAnnualReportIdForIncomeStatement != null) {
                    this.annualReportProvider.dispatchIncomeAutoFillFromChosenOrSavedId(annualReport.autoFillAnnualReportIdForIncomeStatement);
                }

                // Applying autoFill from previous if there is previous annual report
                this.applyAutoFillFromPreviousAnnualReport();

            }

            if (
                this.isPreviousYearDataTakenFromPreviousBalanceAnnualReport ||
                this.isPreviousYearDataTakenFromPreviousIncomeAnnualReport
            ) {
                this.setPreviousYearClosingIncomeValue();
            }
        }
        this.updateData();



    }

    private setDates(generalInformationData: IGeneralInformation): void {
        const balancePreviousDisplayDate = generalInformationData.noPreviousData
            ? this.noPreviousDatePlaceholder
            : generalInformationData.balancePreviousYearDate;
        const balanceCurrentDisplayDate = generalInformationData.balanceSheetDate;
        const incomePreviousDisplayDate = generalInformationData.noPreviousData
            ? this.noPreviousDatePlaceholder
            : this.dateLocalPipe.transform(generalInformationData.incomePreviousYearFromDate).toString() +
            '-' +
            (generalInformationData.incomePreviousYearToDate != null
                ? this.dateLocalPipe.transform(generalInformationData.incomePreviousYearToDate).toString()
                : '');
        const incomeCurrentDisplayDate =
            this.dateLocalPipe.transform(generalInformationData.incomeCurrentYearFromDate).toString() +
            '-' +
            (generalInformationData.incomeCurrentYearToDate != null
                ? this.dateLocalPipe.transform(generalInformationData.incomeCurrentYearToDate).toString()
                : '');
        this.accountMappingInput.dates = {
            balanceStartDate: balancePreviousDisplayDate,
            balanceEndDate: balanceCurrentDisplayDate,
            incomeStartDate: incomePreviousDisplayDate,
            incomeEndDate: incomeCurrentDisplayDate,
        };
        this.onPrerequisiteDataInitialized();
    }

    private handleEditMode(
        annualReport: IAnnualReport,
        finStatements: IFinStatements[],
        balanceIndex: number,
        incomeIndex: number,
    ) {

        this.isSavedMode = true;
        // if we are in edit mode and the file has changed, then we have 2 cases
        // 1. we use the current annual report's saved mapping
        // 2. if the current has no mapping, then we use autofill from previous annual report
        if (this.fileChanged) {
            // check if all finstatements have mappings to be used
            const canUseCurrentMapping: boolean =
                FinancialStatementAccountMappingFormHelper.isAllFinStatementsHaveMapping(finStatements);

            if (canUseCurrentMapping) {
                // case 1
                this.reuseCurrentMapping(finStatements, balanceIndex, incomeIndex);
            } else {
                // case 2
                this.applyAutoFillFromPreviousAnnualReport();
            }
        } else {
            this.reuseCurrentMapping(finStatements, balanceIndex, incomeIndex);
        }
    }

    private reuseCurrentMapping(finStatements: IFinStatements[], balanceIndex: number, incomeIndex: number) {
        this.accountMappingInput = cloneDeep(this.accountMappingInput);
        this.setBalanceAccountMappingData(finStatements, balanceIndex);
        this.setIncomeAccountMappingData(finStatements, incomeIndex);

        this.onPrerequisiteDataInitialized();
    }


    private applyAutoFillFromPreviousAnnualReport() {
        this.templatesProvider
            .getDefaultGroups$()
            .pipe(
                tap((defaultGroups) => this.handleDefaultGroups(defaultGroups)),
                mergeMap(() => this.annualReportProvider.getSelectedYearForUploadAndMappingAutofillFinStatements$()),
                mergeMap((finstatements) => {
                    if (finstatements == null || finstatements.length == 0) {
                        return this.annualReportProvider.getCombinedAutofillFinStatements$();
                    } else {
                        this.isGetAnnualReportForUploadAndMappingAutoFill = true;

                        return of(finstatements);
                    }
                }),
                filter((finstatements: IFinStatements[]) => finstatements != null && finstatements.length >= 2 && finstatements[this.balanceIndexInFinStatementsArray] != null && finstatements[this.incomeIndexInFinStatementsArray] != null),
                untilDestroyed(this),
            )
            .subscribe((autofillFinStatements) => {
                const isPreviousDataTakenFromPreviousAnnualReport =
                    this.activeAnnualReport.generalInformation.isPreviousDataTakenFromPreviousAnnualReport;
                if (autofillFinStatements.length >= templateConstants.financialStatementMinimumLength) {
                    const autofilledMapping = FinancialStatementAccountMappingFormHelper.prepareAccountMappingInput(
                        autofillFinStatements,
                        this.defaultTemplatesGroups,
                        this.balanceAccounts,
                        this.incomeAccounts,
                        isPreviousDataTakenFromPreviousAnnualReport,
                        this.activeAnnualReport.locale.toLocaleLowerCase(),
                        this.isGetAnnualReportForUploadAndMappingAutoFill,
                    );

                    // Keep a copy of the source fin statements for both autofill modes
                    // (selected-year copy and previous-year combined autofill) so
                    // template-level reclassesAccounts can be transferred on save.
                    this.copiedFinStatements = cloneDeep(autofillFinStatements);

                    if (this.isGetAnnualReportForUploadAndMappingAutoFill) {
                        //In this case we copy from another report
                        this.copiedFinStatements = cloneDeep(autofillFinStatements);
                    }
                    let previousYearBalanceDuplicateAccountNumber: Set<string>;
                    if (autofillFinStatements[this.balanceIndexInFinStatementsArray]) {
                        previousYearBalanceDuplicateAccountNumber =
                            FinancialStatementAccountMappingFormHelper.getDuplicateAccountNumber(
                                autofillFinStatements[this.balanceIndexInFinStatementsArray].templateAndAccountsMapping
                                    .accounts,
                            );
                    }

                    let previousYearIncomeDuplicateAccountNumber: Set<string>;
                    if (autofillFinStatements[this.incomeIndexInFinStatementsArray]) {
                        previousYearIncomeDuplicateAccountNumber =
                            FinancialStatementAccountMappingFormHelper.getDuplicateAccountNumber(
                                autofillFinStatements[this.incomeIndexInFinStatementsArray].templateAndAccountsMapping
                                    .accounts,
                            );
                    }

                    this.accountMappingInput = {
                        // we want everything in the account mapping to stay the same ( ex. dates)
                        // and only copy the actual mapping from the autofilled annual report
                        ...this.accountMappingInput,
                        balance: autofilledMapping.balance,
                        income: autofilledMapping.income,
                        previousYearBalanceDuplicateAccountNumber,
                        previousYearIncomeDuplicateAccountNumber,
                        uncoveredShortfallAssetsFli: (autofilledMapping.balance?.template as IAccountMappingTemplate)?.uncoveredShortfallAssetsFli ?? this.accountMappingInput.uncoveredShortfallAssetsFli,
                        uncoveredShortfallLiabilitiesFli: (autofilledMapping.balance?.template as IAccountMappingTemplate)?.uncoveredShortfallLiabilitiesFli ?? this.accountMappingInput.uncoveredShortfallLiabilitiesFli,
                    };

                }

                this.onPrerequisiteDataInitialized();
            });

        this.annualReportProvider.getGroupingMaskingForBalanceAutofill$()
            .pipe(
                tap((groupingMasking) => {
                    if (groupingMasking != null) {
                        this.autofillGroupingMasking = groupingMasking;
                    }
                }),
                untilDestroyed(this),
            )
            .subscribe();
        this.annualReportProvider.getGroupingMaskingForCopyAutofill$()
            .pipe(
                tap((groupingMasking) => {
                    if (groupingMasking != null) {
                        this.autofillGroupingMasking = groupingMasking;
                    }
                }),
                untilDestroyed(this),
            )
            .subscribe();
    }

    private setBalanceAccountMappingData(finStatements: IFinStatements[], index: number) {
        const importObjectBalance = finStatements[index].import;
        const balanceTemplateMapping = finStatements[index].templateAndAccountsMapping;
        this.accountMappingInput.balance = {
            template: balanceTemplateMapping.template as IAccountMappingTemplate,
            status: AccountMappingTemplateStatus.MAPPED,
            accounts: balanceTemplateMapping.accounts as unknown as IAccount[],
            balanceSwitchAccounts:
                balanceTemplateMapping.balanceSwitchAccounts != null
                    ? balanceTemplateMapping.balanceSwitchAccounts
                    : [],
        };
        this.accountMappingInput.sheetSystem = importObjectBalance.interpretation;
        this.accountMappingInput.uncoveredShortfallAssetsFli =
            balanceTemplateMapping.template.uncoveredShortfallAssetsFli;

        if (this.accountMappingInput.importedTaxonomyDefinitions != null) {
            this.accountMappingInput.importedTaxonomyDefinitions.rawBalanceTemplate.profitOfTheYear =
                balanceTemplateMapping.template.profitOfTheYear;
            this.accountMappingInput.importedTaxonomyDefinitions.rawBalanceTemplate.annualSurplusFli =
                balanceTemplateMapping.template.annualSurplusFli;
        }

        this.accountMappingInput.uncoveredShortfallLiabilitiesFli =
            balanceTemplateMapping.template.uncoveredShortfallLiabilitiesFli;

        this.uncoveredShortfallAssetsFliName = balanceTemplateMapping?.template?.uncoveredShortfallAssetsFli;
        this.uncoveredShortfallLiabilitiesFliName = balanceTemplateMapping?.template?.uncoveredShortfallLiabilitiesFli;
    }

    private setIncomeAccountMappingData(finStatements: IFinStatements[], index: number) {
        const incomeTemplateMapping = finStatements[index].templateAndAccountsMapping;
        this.accountMappingInput.income = {
            template: incomeTemplateMapping.template as IAccountMappingTemplate,
            status: AccountMappingTemplateStatus.MAPPED,
            accounts: incomeTemplateMapping.accounts as unknown as IAccount[],
        };
    }

    private handleTemplateResponse(template: ITemplateEntityDTO) {
        this.dataState = DataState.Success;
        this.templateNotFoundError = false;

        if (template.type === TemplateType.INCOME) {
            this.rawIncomeTemplate = template;
        } else if (template.type === TemplateType.BALANCE) {
            this.rawBalanceTemplate = template;
            this.profitOfTheYearFliName = this.rawBalanceTemplate.profitOfTheYear;
            this.annualSurplusFliName = this.rawBalanceTemplate.annualSurplusFliName;
            this.cashAndCashFli = this.rawBalanceTemplate.cashAndCash;
        }

        this.updateData();
    }
    private handleDefaultGroups(groups: Map<string, IGroupEntityDTO>): void {
        this.defaultTemplatesGroups = cloneDeep<Map<string, IGroupEntityDTO>>(groups);
    }

    updateData() {
        this.accountMappingInput = cloneDeep(this.accountMappingInput);
        // just update if no template was previously found
        if (
            this.rawIncomeTemplate != null &&
            (this.accountMappingInput == null ||
                this.accountMappingInput.income == null ||
                this.accountMappingInput.income.template == null)
        ) {
            this.accountMappingInput.income = {
                template: this.rawIncomeTemplate,
                status: AccountMappingTemplateStatus.NEW,
                accounts: this.incomeAccounts,
            };
        }

        if (
            this.rawBalanceTemplate != null &&
            (this.accountMappingInput == null ||
                this.accountMappingInput.balance == null ||
                this.accountMappingInput.balance.template == null)
        ) {
            this.accountMappingInput.balance = {
                template: this.rawBalanceTemplate,
                status: AccountMappingTemplateStatus.NEW,
                accounts: this.balanceAccounts,
                balanceSwitchAccounts: this.balanceSwitchAccounts,
            };
            if (this.accountMappingInput.importedTaxonomyDefinitions != null) {
                this.accountMappingInput.uncoveredShortfallAssetsFli =
                    this.accountMappingInput.importedTaxonomyDefinitions.rawBalanceTemplate.uncoveredShortfallAssetsFli;
                this.accountMappingInput.uncoveredShortfallLiabilitiesFli =
                    this.accountMappingInput.importedTaxonomyDefinitions.rawBalanceTemplate.uncoveredShortfallLiabilitiesFli;
            } else {
                this.accountMappingInput.uncoveredShortfallAssetsFli =
                    this.rawBalanceTemplate.uncoveredShortfallAssetsFli;
                this.accountMappingInput.uncoveredShortfallLiabilitiesFli =
                    this.rawBalanceTemplate.uncoveredShortfallLiabilitiesFli;
            }
        }

        if (this.balanceAccounts && this.fileChanged) {
            if (this.balanceAccounts.length && this.accountMappingInput.balance != null) {
                this.accountMappingInput.balance.accounts = [...this.balanceAccounts];
            }
        }
        if (this.incomeAccounts && this.fileChanged) {
            if (this.incomeAccounts.length && this.accountMappingInput.income != null) {
                this.accountMappingInput.income.accounts = [...this.incomeAccounts];
            }
        }

        this.onPrerequisiteDataInitialized();

        // to force change detection in the child component
    }

    private handleFinancialStatementSourceResponse(
        financialStatementSource: IFinancialStatementSource,
        isBalance: boolean,
    ) {
        this.financialStatementSource[financialStatementSource.type] = financialStatementSource;
        if (isBalance && financialStatementSource.interpretation) {
            this.accountMappingInput.sheetSystem = financialStatementSource.interpretation;
        }
    }

    private defineSettings(): void {
        if (this.activeAnnualReport.annualReportTemplate != null) {
            this.isCashFlowTypeForFliUsed =
                this.activeAnnualReport.annualReportTemplate.businessModel === AnnualReportBusinessModel.OR;
            this.businessModel = this.activeAnnualReport.annualReportTemplate.businessModel;
        }

        // Try getting uncoveredShortfall setting from ar template first
        // If it's not defined, then we disable it

        let applyUncoveredShortfall = false;
        try {
            if (
                this.activeAnnualReport.annualReportTemplate != null &&
                this.activeAnnualReport.annualReportTemplate.settings != null &&
                this.activeAnnualReport.annualReportTemplate.settings.uncoveredShortfall != null
            ) {
                applyUncoveredShortfall =
                    this.activeAnnualReport.annualReportTemplate?.settings?.uncoveredShortfall ?? false;
            }
        } catch (error) {
            applyUncoveredShortfall = false;
            debug('defineSettings', error);
        }

        this.accountMappingInput.applyUncoveredShortfall = applyUncoveredShortfall;
    }

    onDeleteSwitchAccountClicked(): void {
        if (this.debuggingFeaturesEnabled) {

            this.openWipeSwitchAccountDialog = true;
        }
    }

    onWipeSwitchAccountConfirm() {

        if (this.debuggingFeaturesEnabled) {

            this.deleteSwitchAccount = true;
            this.save();
            this.openWipeSwitchAccountDialog = false;
        }
    }

    proceedButtonClicked = (): void => {
        this.save();
    };

    override save(): Observable<void> {
        this.mixpanelService.track(MIXPANEL_EVENTS.UPLOAD_SHEET_TIME_SPENT_TILL_COMPLETION);
        this.isSaveRequestInProgress = true;
        const annualReportToBeSaved = this.getAnnualReportToBeSaved();
        if (annualReportToBeSaved == null) {
            return of(void 0);
        }
        this.dispatchSaveAnnualReport(annualReportToBeSaved);
        this.enforceGlobalStateUpdate(annualReportToBeSaved);
        return of(void 0);
    }

    protected onSaveSuccessfully(): void {
        this.isSaveRequestInProgress = false;

        const modifiedBalanceMappingTemplate = cloneDeep<IAccountMappingTemplate>(this.balanceFinancialStatementMapping?.template);
        this.cleanSortedItemsRecursive(modifiedBalanceMappingTemplate.group.sortedItems, ['isDuplicateAccountNumber', 'isEndOfDuplicateAccounts', 'isSummarized']);


        const modifiedIncomeMappingTemplate = cloneDeep<IAccountMappingTemplate>(this.incomeFinancialStatementMapping?.template);
        this.cleanSortedItemsRecursive(modifiedIncomeMappingTemplate.group.sortedItems, ['isDuplicateAccountNumber', 'isEndOfDuplicateAccounts', 'isSummarized']);


        // Update the activeFinStatements with the saved data so that further change detection works correctly
        this.activeFinStatements[this.balanceIndexInFinStatementsArray].templateAndAccountsMapping.template = cloneDeep<ITemplateAndAccountsMapping>(modifiedBalanceMappingTemplate);
        this.activeFinStatements[this.incomeIndexInFinStatementsArray].templateAndAccountsMapping.template = cloneDeep<ITemplateAndAccountsMapping>(modifiedIncomeMappingTemplate);

        this.isSavedMode = true;
        this.savedSuccessfully.next(true);
        this.fireSuccessNotification();
        if (this.debuggingFeaturesEnabled) {
            this.deleteSwitchAccount = false;
            // TODO: navigate to project overview
        }
    }

    private onSaveFailed(): void {
        this.isSaveRequestInProgress = false;
        this.savedSuccessfully.next(false);
        this.fireErrorMessage();
    }

    /**
     * Merge an autofill source's translation block into `autofillTranslations`, per language. Entries
     * are unioned (a later source wins on the same source text); `declined` is deliberately dropped so
     * a new report may prompt again.
     */
    private mergeAutofillTranslations(source: ITranslations | null | undefined): void {
        if (source == null) {
            return;
        }
        const merged: ITranslations = this.autofillTranslations ?? {};
        Object.entries(source).forEach(([locale, bucket]) => {
            merged[locale] = { entries: { ...(merged[locale]?.entries ?? {}), ...(bucket.entries ?? {}) } };
        });
        this.autofillTranslations = merged;
    }

    private prepareFinancialStatementsForAnnualReportSaving(
        activeAnnualReport: IAnnualReport,
        activeFinStatements: IFinStatements[],
        balanceFinancialStatementMapping: IAccountMappingDataMapped,
        incomeFinancialStatementMapping: IAccountMappingDataMapped,
        isDataChanged: boolean,
    ): IAnnualReport {
        const annualReportToBeSaved = cloneDeep<IAnnualReport>(activeAnnualReport);
        // It's required to replace annualReportToBeSaved.finStatements with the activeFinStatements
        // and then from here on we can modify the .finStatements of annualReportToBeSaved directly
        annualReportToBeSaved.finStatements = cloneDeep<IAnnualReport>(activeFinStatements);

        // add grouping and masking from previous year if required.
        // REV-20899: this runs ONLY for a fresh autofill. `copiedFinStatements` is
        // set exclusively in applyAutoFillFromPreviousAnnualReport (a newly created
        // report with no own mapping yet — see the canUseCurrentMapping branch), so
        // it never fires when reopening an existing report. We run it even when the
        // source has NO groupingAndMasking object (a pure legacy source): otherwise
        // a second year created from a legacy report never gets
        // reclassificationsVersion = 1 and is mis-classified as a legacy (old-tab)
        // report in grouping & masking.
        if (this.autofillGroupingMasking != null || this.copiedFinStatements != null) {
            const existingReclassifications = annualReportToBeSaved.groupingAndMasking?.reclassifications;
            const hasOwnReclassifications =
                Array.isArray(existingReclassifications) && existingReclassifications.length > 0;

            // Seed reclass transactions from the source (if any) when the current AR
            // has no own transactions yet, and stamp version 1 so the report is
            // treated as transactional (inherited legacy reclasses become the
            // read-only frozen reference in the old tab; new reclasses are entered
            // here in grouping & masking).
            if (!hasOwnReclassifications) {
                const sourceGm = this.autofillGroupingMasking;
                const prevReclassifications: IReclassificationTransaction[] =
                    sourceGm != null && Array.isArray(sourceGm.reclassifications) ? sourceGm.reclassifications : [];

                const shiftedReclassifications: IReclassificationTransaction[] = prevReclassifications
                    .filter((t) => t.period === ReclassificationPeriod.CURRENT_YEAR)
                    .map((t) => ({
                        ...t,
                        period: ReclassificationPeriod.PREVIOUS_YEAR,
                        id:
                            typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
                                ? crypto.randomUUID()
                                : 'r-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10),
                    }));

                annualReportToBeSaved.groupingAndMasking = {
                    // Complete IGroupingMasking defaults so the object stays valid
                    // when neither the source nor the current AR has a G&M object
                    // (pure legacy source + freshly created report). sourceGm (if
                    // present) overrides these to carry the previous year's
                    // sorting/grouping/masking.
                    enabled: false,
                    sorting: {},
                    renamedAccounts: {},
                    groupedAccounts: {},
                    splitGroupAccounts: {},
                    ...(sourceGm ?? {}),
                    ...annualReportToBeSaved.groupingAndMasking,
                    reclassifications: shiftedReclassifications,
                    // Always stamp version 1 so the display engine (grouping-masking
                    // component, provider selectors, cashflow, notes, etc.) treats
                    // these as transactional reclassifications and renders them.
                    // We cannot rely on the spread order to supply this: sourceGm
                    // might not have the flag yet (e.g. if it was saved before the
                    // transactional model was introduced), and the current AR's
                    // groupingAndMasking might override it with undefined/0.
                    reclassificationsVersion: 1,
                    // Do not carry forward the PY lock — the new AR starts unlocked
                    // so the user can review and adjust the autofilled PY entries.
                    reclassPyLocked: false,
                };
            }
        }

        // Carry the saved translations over from the autofill source(s). Only on a fresh autofill
        // (the report has no own block yet); unchanged source texts stay covered, changed ones fall
        // out by their key and are reported as gaps again.
        if (annualReportToBeSaved.translations == null && this.autofillTranslations != null) {
            annualReportToBeSaved.translations = this.autofillTranslations;
        }

        const balanceIndex =
            FinancialStatementAccountMappingFormHelper.getIndexForFinancialStatementSourceFromActiveAnnualReport(
                annualReportToBeSaved.finStatements,
                FinancialStatementTypes.BALANCE,
            );
        balanceFinancialStatementMapping.template.profitOfTheYear = this.profitOfTheYearFliName;
        balanceFinancialStatementMapping.template.annualSurplusFli = this.annualSurplusFliName;
        balanceFinancialStatementMapping.template.uncoveredShortfallAssetsFli = this.uncoveredShortfallAssetsFliName;
        balanceFinancialStatementMapping.template.uncoveredShortfallLiabilitiesFli = this.uncoveredShortfallLiabilitiesFliName;
        annualReportToBeSaved.finStatements[balanceIndex].templateAndAccountsMapping = {
            accounts: balanceFinancialStatementMapping.accounts,
            template: balanceFinancialStatementMapping.template,
            balanceSwitchAccounts: balanceFinancialStatementMapping.balanceSwitchAccounts,
        };

        let { version } = annualReportToBeSaved.finStatements[balanceIndex] ?? { version: 0 };
        annualReportToBeSaved.finStatements[balanceIndex].version = isDataChanged ? version + 1 : version;

        const incomeIndex =
            FinancialStatementAccountMappingFormHelper.getIndexForFinancialStatementSourceFromActiveAnnualReport(
                annualReportToBeSaved.finStatements,
                FinancialStatementTypes.INCOME,
            );
        annualReportToBeSaved.finStatements[incomeIndex].templateAndAccountsMapping = {
            accounts: incomeFinancialStatementMapping.accounts,
            template: incomeFinancialStatementMapping.template,
        };

        const autofillDuplicateUidMap = this.alignAutofilledDuplicateUniqueAccountIds(
            annualReportToBeSaved.finStatements,
            this.copiedFinStatements,
            balanceIndex,
            incomeIndex,
        );

        if (Array.isArray(annualReportToBeSaved.groupingAndMasking?.reclassifications)) {
            this.remapAutofilledReclassRefsToCurrentDuplicateIds(
                annualReportToBeSaved.groupingAndMasking.reclassifications,
                autofillDuplicateUidMap,
            );
        }

        // REV-20899: carry over template-level reclassesAccounts from the autofill
        // source report so second-year autofill includes reclasses accounts too.
        this.copyReclassesAccountsFromAutofill(
            annualReportToBeSaved.finStatements,
            this.copiedFinStatements,
            balanceIndex,
            incomeIndex,
        );

        annualReportToBeSaved.finStatements[incomeIndex].version = isDataChanged ? version + 1 : version;

        if (this.deleteSwitchAccount) {
            const balanceAccounts = annualReportToBeSaved.finStatements[balanceIndex].templateAndAccountsMapping.accounts;
            const balanceTemplate = annualReportToBeSaved.finStatements[balanceIndex].templateAndAccountsMapping.template;

            const PROPERTIES_TO_STRIP = [
                "originalClosingBalance",
                "originalOpeningBalance",
                "originsFromAsset",
                "balanceSwitchAccountId",
                "interpretation",
            ];

            const legacyAccounts = balanceAccounts.map(account => {

                // For each property in the list, attempt to delete it from the current account object
                PROPERTIES_TO_STRIP.forEach(propertyKey => {
                    // The `delete` operator is the standard way to remove a key from a JS object
                    delete account[propertyKey];
                });

                // Return the cleaned-up account object
                return account;
            });
            annualReportToBeSaved.finStatements[balanceIndex].templateAndAccountsMapping.accounts = legacyAccounts;

            const legacyBalanceSwitchAccounts = annualReportToBeSaved.finStatements[balanceIndex].templateAndAccountsMapping
                .balanceSwitchAccounts?.map(switchAccount => {
                    PROPERTIES_TO_STRIP.forEach(propertyKey => {
                        delete switchAccount[propertyKey];
                    });
                    return switchAccount;
                });

            annualReportToBeSaved.finStatements[balanceIndex].templateAndAccountsMapping.balanceSwitchAccounts =
                legacyBalanceSwitchAccounts;


            this.cleanSortedItemsRecursive(balanceTemplate.group.sortedItems, PROPERTIES_TO_STRIP);
        }
        return annualReportToBeSaved;
    }

    private copyReclassesAccountsFromAutofill(
        targetFinStatements: IFinStatements[],
        sourceFinStatements: IFinStatements[] | undefined,
        balanceIndex: number,
        incomeIndex: number,
    ): void {
        if (!Array.isArray(sourceFinStatements) || sourceFinStatements.length < templateConstants.financialStatementMinimumLength) {
            return;
        }

        const copyForIndex = (idx: number): void => {
            const sourceTemplate = sourceFinStatements?.[idx]?.templateAndAccountsMapping?.template as any;
            const targetTemplate = targetFinStatements?.[idx]?.templateAndAccountsMapping?.template as any;
            if (!sourceTemplate?.group || !targetTemplate?.group) return;
            this.copyTemplateReclassesAccounts(sourceTemplate.group, targetTemplate.group);
        };

        copyForIndex(balanceIndex);
        copyForIndex(incomeIndex);
    }

    private copyTemplateReclassesAccounts(sourceGroup: any, targetGroup: any): void {
        if (sourceGroup == null || targetGroup == null) return;

        const sourceFlis = this.collectFliMap(sourceGroup);
        const targetFlis = this.collectFliMap(targetGroup);

        for (const [fliName, targetFli] of targetFlis) {
            const sourceFli = sourceFlis.get(fliName);
            if (!sourceFli) continue;

            if (Array.isArray(sourceFli.reclassesAccounts)) {
                targetFli.reclassesAccounts = cloneDeep(sourceFli.reclassesAccounts);
                this.advanceCarriedReclassesAccountsOneYear(targetFli.reclassesAccounts);
            }

            const sourceSubMap = this.collectSubFliMap(sourceFli);
            const targetSubMap = this.collectSubFliMap(targetFli);
            for (const [subKey, targetSub] of targetSubMap) {
                const sourceSub = sourceSubMap.get(subKey);
                if (sourceSub && Array.isArray(sourceSub.reclassesAccounts)) {
                    targetSub.reclassesAccounts = cloneDeep(sourceSub.reclassesAccounts);
                    this.advanceCarriedReclassesAccountsOneYear(targetSub.reclassesAccounts);
                }
            }
        }
    }

    private advanceCarriedReclassesAccountsOneYear(reclassesAccounts: unknown[]): void {
        if (!Array.isArray(reclassesAccounts)) return;
        for (const reclassesAccount of reclassesAccounts) {
            FinancialStatementAccountMappingFormHelper.autoFillReclassesInAccount(
                reclassesAccount as IAccount | IReclassesAccounts,
            );
        }
    }

    private collectFliMap(group: any): Map<string, any> {
        const map = new Map<string, any>();
        const walk = (g: any): void => {
            if (g == null) return;
            const items = (Array.isArray(g.sortedItems) ? g.sortedItems : null) ?? (Array.isArray(g.items) ? g.items : null);
            if (items) {
                for (const item of items) {
                    if (item == null) continue;
                    if (item.type === ItemType.FLI && item.name != null) {
                        map.set(item.name, item);
                    } else if ('sortedItems' in item || 'items' in item) {
                        walk(item);
                    }
                }
            }
            if (Array.isArray(g.groups)) {
                for (const sub of g.groups) walk(sub);
            }
        };
        walk(group);
        return map;
    }

    private collectSubFliMap(fli: any): Map<string, any> {
        const map = new Map<string, any>();
        if (!Array.isArray(fli?.accounts)) return map;
        for (const account of fli.accounts) {
            if (account == null) continue;
            if (account.type === ItemType.SUB_FLI || account.type === ItemType.OF_THAT_ITEM) {
                const key = `${account.type}|${account.name ?? ''}`;
                map.set(key, account);
            }
        }
        return map;
    }

    private alignAutofilledDuplicateUniqueAccountIds(
        targetFinStatements: IFinStatements[],
        sourceFinStatements: IFinStatements[] | undefined,
        balanceIndex: number,
        incomeIndex: number,
    ): Map<string, string> {
        const map = new Map<string, string>();

        if (!Array.isArray(sourceFinStatements) || sourceFinStatements.length < templateConstants.financialStatementMinimumLength) {
            return map;
        }

        this.alignAutofilledDuplicateIdsForStatementIndex(sourceFinStatements, targetFinStatements, balanceIndex, map);
        this.alignAutofilledDuplicateIdsForStatementIndex(sourceFinStatements, targetFinStatements, incomeIndex, map);

        return map;
    }

    private alignAutofilledDuplicateIdsForStatementIndex(
        sourceFinStatements: IFinStatements[],
        targetFinStatements: IFinStatements[],
        index: number,
        duplicateUidMap: Map<string, string>,
    ): void {
        const sourceMapping = sourceFinStatements?.[index]?.templateAndAccountsMapping;
        const targetMapping = targetFinStatements?.[index]?.templateAndAccountsMapping;
        const finStmtType = targetFinStatements?.[index]?.type;
        if (!sourceMapping || !targetMapping || finStmtType == null) return;

        // Convert FinancialStatementTypes ('balance'/'income') to the
        // ReclassificationStatement value used on transactions
        // ('BALANCE_SHEET'/'INCOME_STATEMENT') so the map keys match what
        // remapAutofilledReclassRefsToCurrentDuplicateIds looks up.
        const reclassStmtKey =
            finStmtType === FinancialStatementTypes.BALANCE ? 'BALANCE_SHEET' : 'INCOME_STATEMENT';

        // Use the flat accounts list to identify true duplicates — accounts that
        // appear more than once in the flat list are mapped to multiple FLIs.
        const sourceAccounts = this.collectTemplateAccountsByTwoPartKey(sourceMapping.accounts);
        const targetAccounts = this.collectTemplateAccountsByTwoPartKey(targetMapping.accounts);

        for (const [twoPartKey, sourceEntries] of sourceAccounts) {
            if (sourceEntries.length < 2) continue;
            const targetEntries = targetAccounts.get(twoPartKey) ?? [];
            if (targetEntries.length < 2) continue;

            const max = Math.min(sourceEntries.length, targetEntries.length);
            for (let index = 0; index < max; index++) {
                const sourceUid = sourceEntries[index].uniqueAccountId;
                if (!sourceUid) continue;

                const targetAccount = targetEntries[index].account;
                if (!targetAccount.uniqueAccountId) {
                    targetAccount.uniqueAccountId = sourceUid;
                }

                duplicateUidMap.set(`${reclassStmtKey}|${sourceUid}`, targetAccount.uniqueAccountId);
            }
        }
    }

    private remapAutofilledReclassRefsToCurrentDuplicateIds(
        transactions: IReclassificationTransaction[],
        duplicateUidMap: Map<string, string>,
    ): void {
        if (!Array.isArray(transactions) || transactions.length === 0 || duplicateUidMap.size === 0) {
            return;
        }

        const remapRef = (statement: string | undefined, ref: any): void => {
            const uniqueAccountId = ref?.uniqueAccountId;
            if (!statement || !uniqueAccountId) return;
            // Map key uses ReclassificationStatement values (BALANCE_SHEET / INCOME_STATEMENT)
            // which match transaction.statement directly.
            const mapped = duplicateUidMap.get(`${statement}|${uniqueAccountId}`);
            if (mapped) {
                ref.uniqueAccountId = mapped;
            }
        };

        for (const transaction of transactions as any[]) {
            const statement = transaction?.statement as string | undefined;
            const sourceRef = transaction?.source ?? transaction?.['sourceRef'];
            const targetRef = transaction?.target ?? transaction?.['targetRef'];
            remapRef(statement, sourceRef);
            remapRef(statement, targetRef);
        }
    }

    private collectTemplateAccountsByTwoPartKey(
        accounts: any[],
    ): Map<string, Array<{ account: any; uniqueAccountId?: string }>> {
        const map = new Map<string, Array<{ account: any; uniqueAccountId?: string }>>();
        if (!Array.isArray(accounts)) return map;
        for (const acc of accounts) {
            if (acc == null || acc.accountNumber == null) continue;
            const key = `${acc.accountNumber}|${acc.name ?? ''}`;
            const list = map.get(key) ?? [];
            list.push({ account: acc, uniqueAccountId: acc.uniqueAccountId });
            map.set(key, list);
        }
        return map;
    }

    /**
     * Recursively cleans nested account and sortedItem structures by stripping properties.
     * * @param {Array<Object>} items - An array of sortedItem objects (can be the top level or nested).
     * @param {Array<string>} propertiesToStrip - The keys to delete from account objects.
     * @returns {Array<Object>} The cleaned array.
     */
    cleanSortedItemsRecursive(items, propertiesToStrip) {
        if (!items || items.length === 0) {
            return items;
        }

        return items.map(item => {
            // --- 1. Clean Accounts (Handles the single nested account level) ---
            if (item.accounts && item.accounts.length > 0) {
                item.accounts = item.accounts.map(account => {

                    // Delete properties from the top-level account
                    propertiesToStrip.forEach(key => delete account[key]);

                    // Check and clean the single allowed nested account level
                    if (account.accounts && account.accounts.length > 0) {
                        account.accounts = account.accounts.map(nestedAccount => {
                            propertiesToStrip.forEach(key => delete nestedAccount[key]);
                            return nestedAccount;
                        });
                    }
                    return account;
                });
            }

            // --- 2. Recurse on Nested Sorted Items ---
            if (item.sortedItems && item.sortedItems.length > 0) {
                // !!! THIS IS THE CRITICAL LINE !!!
                // Call the same function again with the nested array
                item.sortedItems = this.cleanSortedItemsRecursive(item.sortedItems, propertiesToStrip);
            }

            return item;
        });
    }

    protected override isDataConsistent(): Observable<ConsistencyCheckResult> {
        const annualReportToBeSaved = this.getAnnualReportToBeSaved();
        // here on we can modify the .finStatements of annualReportToBeSaved directly, it's fine
        if (
            annualReportToBeSaved == null ||
            (annualReportToBeSaved != null &&
                annualReportToBeSaved.finStatements.length >= templateConstants.financialStatementMinimumLength &&
                (annualReportToBeSaved.finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping
                    .template == null ||
                    annualReportToBeSaved.finStatements[templateConstants.incomeTemplate].templateAndAccountsMapping
                        .template == null))
        ) {
            return of({ isDataConsistent: true, warnings: [] });
        }

        const balanceTemplate =
            annualReportToBeSaved.finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template;

        const incomeTemplate =
            annualReportToBeSaved.finStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template;

        let assetsAndLiabilitiesEqualityCheckResult: EqualityChecksResult;
        let profitIncomeAndProfitFliEqualityCheck: EqualityChecksResult;

        try {
            assetsAndLiabilitiesEqualityCheckResult =
                EqualityChecksHelper.checkAssetsEqualLiabilities(balanceTemplate);

            profitIncomeAndProfitFliEqualityCheck = EqualityChecksHelper.checkProfitIncomeEqualProfitFLI(
                balanceTemplate,
                incomeTemplate,
            );
        } catch (error) {
            console.error('Error during equality checks:', error);
            assetsAndLiabilitiesEqualityCheckResult = EqualityChecksResult.BOTH_EQUAL;
            profitIncomeAndProfitFliEqualityCheck = EqualityChecksResult.BOTH_EQUAL;
        }


        if (
            assetsAndLiabilitiesEqualityCheckResult !== EqualityChecksResult.BOTH_EQUAL ||
            profitIncomeAndProfitFliEqualityCheck !== EqualityChecksResult.BOTH_EQUAL
        ) {
            const warnings = this.getEqualityCheckDialogLocalizationKey(
                assetsAndLiabilitiesEqualityCheckResult,
                profitIncomeAndProfitFliEqualityCheck,
            );
            return of({
                isDataConsistent: false,
                warnings: warnings,
            });
        } else {
            return of({ isDataConsistent: true, warnings: [] });
        }
    }

    private getEqualityCheckDialogLocalizationKey(
        assetsAndLiabilitiesEqualityCheckResult: EqualityChecksResult,
        profitIncomeAndProfitFliEqualityCheckResult: EqualityChecksResult,
    ): string[] {
        let assetsAndLiabilitiesEqualityCheckResultLocalizationKey: string;
        let profitIncomeAndProfitFliEqualityCheckResultLocalizationKey: string;

        const warningsList: string[] = [];

        switch (assetsAndLiabilitiesEqualityCheckResult) {
            case EqualityChecksResult.BOTH_NOT_EQUAL:
                assetsAndLiabilitiesEqualityCheckResultLocalizationKey =
                    'aumico_reports_equality_check_dialog_assets_and_liabilities_opening_and_closing_not_equal';
                warningsList.push(assetsAndLiabilitiesEqualityCheckResultLocalizationKey);
                break;
            case EqualityChecksResult.CLOSING_NOT_EQUAL:
                assetsAndLiabilitiesEqualityCheckResultLocalizationKey =
                    'aumico_reports_equality_check_dialog_assets_and_liabilities_closing_not_equal';
                warningsList.push(assetsAndLiabilitiesEqualityCheckResultLocalizationKey);
                break;
            case EqualityChecksResult.OPENING_NOT_EQUAL:
                assetsAndLiabilitiesEqualityCheckResultLocalizationKey =
                    'aumico_reports_equality_check_dialog_assets_and_liabilities_opening_not_equal';
                warningsList.push(assetsAndLiabilitiesEqualityCheckResultLocalizationKey);
                break;
            case EqualityChecksResult.BOTH_EQUAL:
                // in case both are equal there is no warning to add to the list
                break;
        }

        switch (profitIncomeAndProfitFliEqualityCheckResult) {
            case EqualityChecksResult.BOTH_NOT_EQUAL:
                profitIncomeAndProfitFliEqualityCheckResultLocalizationKey =
                    'aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_and_closing_not_equal';
                warningsList.push(profitIncomeAndProfitFliEqualityCheckResultLocalizationKey);
                break;
            case EqualityChecksResult.CLOSING_NOT_EQUAL:
                profitIncomeAndProfitFliEqualityCheckResultLocalizationKey =
                    'aumico_reports_equality_check_dialog_profit_income_and_profit_fli_closing_not_equal';
                warningsList.push(profitIncomeAndProfitFliEqualityCheckResultLocalizationKey);
                break;
            case EqualityChecksResult.OPENING_NOT_EQUAL:
                profitIncomeAndProfitFliEqualityCheckResultLocalizationKey =
                    'aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_not_equal';
                warningsList.push(profitIncomeAndProfitFliEqualityCheckResultLocalizationKey);
                break;
            case EqualityChecksResult.BOTH_EQUAL:
                // in case both are equal there is no warning to add to the list
                break;
        }

        return warningsList;
    }

    protected override isShouldNotProceed(): Observable<ShouldNotProceedResult> {
        const annualReportToBeSaved = this.getAnnualReportToBeSaved();
        // here on we can modify the .finStatements of annualReportToBeSaved directly, it's fine
        if (annualReportToBeSaved === undefined) {
            return of({
                shouldNotProceed: false,
                warnings: [],
            });
        }
        const shouldNotProceed = FinancialStatementAccountMappingFormHelper.checkIfAnyGroupHasNoFlis(
            annualReportToBeSaved.finStatements,
        );
        return of({
            shouldNotProceed: shouldNotProceed,
            warnings: [EMPTY_GROUP_WARNING_LOCALIZATION_KEY],
        });
    }

    protected override isDataNewlyCreatedAndSaveable(): boolean {

        if (this.activeAnnualReport && this.disableProceedButton === false) {

            const savedBalanceMapping =
                this.activeFinStatements[this.balanceIndexInFinStatementsArray].templateAndAccountsMapping;
            const savedIncomeMapping =
                this.activeFinStatements[this.incomeIndexInFinStatementsArray].templateAndAccountsMapping;

            return savedBalanceMapping.template == null && savedIncomeMapping.template == null;
        }
        return false;
    }


    protected override isDataChanged(): Observable<boolean> {
        if (this.isSaveRequestInProgress) {
            return this.savedSuccessfully.pipe(map((savedSuccessfully) => !savedSuccessfully));
        }
        if (
            this.autofillGroupingMasking != null &&
            Array.isArray(this.autofillGroupingMasking.reclassifications) &&
            this.autofillGroupingMasking.reclassifications.length > 0 &&
            this.activeAnnualReport?.groupingAndMasking == null
        ) {
            return of(true);
        }
        return of(this.isUnsavedChangesDetected());
    }

    private detectChangesInAccountMappingData(): boolean {
        if (
            this.activeAnnualReport == null ||
            (this.activeAnnualReport != null &&
                this.activeFinStatements.length < templateConstants.financialStatementMinimumLength)
        ) {
            return false;
        }

        if (!this.balanceFinancialStatementMapping || !this.incomeFinancialStatementMapping) {
            return false;
        }
        const propertiesToStrip = ['isDuplicateAccountNumber', 'isEndOfDuplicateAccounts', 'isSummarized'];

        const modifiedBalanceMappingTemplate = cloneDeep(this.balanceFinancialStatementMapping?.template);

        if (!modifiedBalanceMappingTemplate) {
            return false;
        }

        // Properties not needed in detecting changes
        this.cleanSortedItemsRecursive(modifiedBalanceMappingTemplate.group.sortedItems, propertiesToStrip);

        const modifiedIncomeMappingTemplate =
            cloneDeep(this.incomeFinancialStatementMapping?.template);

        if (!modifiedIncomeMappingTemplate) {
            return false;
        }

        // Properties not needed in detecting changes
        this.cleanSortedItemsRecursive(modifiedIncomeMappingTemplate.group.sortedItems, propertiesToStrip);

        const savedBalanceMapping =
            this.activeFinStatements[this.balanceIndexInFinStatementsArray].templateAndAccountsMapping;
        if (savedBalanceMapping && savedBalanceMapping.template) {
            this.cleanSortedItemsRecursive(savedBalanceMapping.template.group.sortedItems, propertiesToStrip);
        }
        const savedIncomeMapping =
            this.activeFinStatements[this.incomeIndexInFinStatementsArray].templateAndAccountsMapping;
        if (savedIncomeMapping && savedIncomeMapping.template) {
            this.cleanSortedItemsRecursive(savedIncomeMapping.template.group.sortedItems, propertiesToStrip);
        }
        const defaultBalanceMapping =
            this.balanceDefaultMapping != null ? omit(this.balanceDefaultMapping, ['status']) : undefined;
        if (defaultBalanceMapping && defaultBalanceMapping.template) {
            this.cleanSortedItemsRecursive(defaultBalanceMapping.template.group.sortedItems, propertiesToStrip);
        }
        const defaultIncomeMapping =
            this.incomeDefaultMapping != null ? omit(this.incomeDefaultMapping, ['status']) : undefined;
        if (defaultIncomeMapping && defaultIncomeMapping.template) {
            this.cleanSortedItemsRecursive(defaultIncomeMapping.template.group.sortedItems, propertiesToStrip);
        }
        /**
         * 
         * Function to instrument and debug differences between objects
         * Useful when deep equality checks fail and you need to find out why
         *
        console.log("Balance Template Differs?", JSON.stringify(modifiedBalanceMappingTemplate) !== JSON.stringify(defaultBalanceMapping.template));
        console.log("Income Template Differs?", JSON.stringify(modifiedIncomeMappingTemplate) !== JSON.stringify(defaultIncomeMapping.template));

        // Visual inspection
        console.log("Modified:", JSON.stringify(modifiedBalanceMappingTemplate));
        console.log("Default:", JSON.stringify(defaultBalanceMapping.template));
        console.log("Modified IS:", JSON.stringify(modifiedIncomeMappingTemplate));
        console.log("Default IS:", JSON.stringify(defaultIncomeMapping.template));

        function getObjectDiff(obj1, obj2, prefix = "") {
            return Object.keys(obj1).reduce((diff, key) => {
                if (obj1[key] === obj2[key]) return diff;
                if (typeof obj1[key] === 'object' && obj2[key] && typeof obj2[key] === 'object') {
                    const deepDiff = getObjectDiff(obj1[key], obj2[key], `${prefix}${key}.`);
                    if (Object.keys(deepDiff).length > 0) return { ...diff, ...deepDiff };
                    return diff;
                }
                return {
                    ...diff,
                    [`${prefix}${key}`]: {
                        old: obj1[key],
                        new: obj2[key],
                        typeOld: typeof obj1[key],
                        typeNew: typeof obj2[key] // Crucial for spotting type mismatches!
                    }
                };
            }, {});
        }

        // Usage inside your function:
        const cleanModified = JSON.parse(JSON.stringify(modifiedBalanceMappingTemplate));
        const cleanDefault = JSON.parse(JSON.stringify(defaultBalanceMapping.template));

        console.log("Differences:", getObjectDiff(cleanDefault, cleanModified));
         */
        // If the prepared default is still the same without changes, then the user did not change anything and could navigate
        // We only need to compare the 'template'. Any change in accounts will be reflected in the template structure
        if (defaultBalanceMapping?.template != null && defaultIncomeMapping?.template != null) {
            const isDefaultValueNotChanged =
                fastDeepEqual(JSON.parse(JSON.stringify(modifiedBalanceMappingTemplate)), JSON.parse(JSON.stringify(defaultBalanceMapping.template))) &&
                fastDeepEqual(JSON.parse(JSON.stringify(modifiedIncomeMappingTemplate)), JSON.parse(JSON.stringify(defaultIncomeMapping.template)));
            if (isDefaultValueNotChanged) {
                return false;
            }
        }

        if (savedBalanceMapping?.template == null || savedIncomeMapping?.template == null) {
            return true;
        }

        const isValueNotChanged =
            fastDeepEqual(JSON.parse(JSON.stringify(modifiedBalanceMappingTemplate)), JSON.parse(JSON.stringify(savedBalanceMapping.template))) &&
            fastDeepEqual(JSON.parse(JSON.stringify(modifiedIncomeMappingTemplate)), JSON.parse(JSON.stringify(savedIncomeMapping.template)));

        return !isValueNotChanged;
    }

    isUnsavedChangesDetected(): boolean {
        return this.detectChangesInAccountMappingData();
    }

    private onPrerequisiteDataInitialized(): void {
        const arebalacenAndIncomeTemplatesExist = this.rawBalanceTemplate != null && this.rawIncomeTemplate != null;
        if (arebalacenAndIncomeTemplatesExist && this.isMappingInputReady) {
            this.disableProceedButton = false;
            this.footerExtraButtonActions[FIRST_ELEMENT_INDEX].disabled = false;
        }
    }

    /**
     * REV-XXXXX: when the current AR is a post-cutover ("new") report and
     * its autofill source (the previous year AR) carries non-zero legacy
     * reclass values on accounts or `reclassesAccounts`, surface a one-time
     * dialog explaining that those values cannot be auto-promoted to the
     * new transactional reclass system. The user must re-enter them as
     * transactions in grouping & masking.
     *
     * Trigger conditions (all must hold):
     *   1. Both the current AR and the autofill source finStatements are
     *      loaded.
     *   2. The current AR is new-world per `isReclassNewWorld`. Legacy
     *      (old-world) reports keep the reclasses tab fully functional,
     *      so no warning is needed there.
     *   3. The current AR has NOT yet saved grouping & masking. The save
     *      flow always stamps `reclassificationsVersion === 1`, so this
     *      flag tells us the user has been through the new reclass workflow
     *      at least once. Past that point we don't want to re-show the
     *      dialog every time they revisit the mapping step — they've
     *      already acknowledged the new system and re-entered (or
     *      intentionally skipped) any reclass they wanted to carry over.
     *   4. The autofill source AR(s) actually carry legacy reclasses. When
     *      the source already uses the transactional model
     *      (`groupingAndMasking.reclassificationsVersion === 1`), any
     *      reclasses live as transactions on the source AR itself. They are
     *      NOT "legacy" values stuck on accounts, and the `closingReClass` /
     *      `openingReClass` numbers we see on the autofill `IFinStatements`
     *      are derived. The user can simply
     *      re-add the same transactions in the new AR's grouping & masking
     *      step, so we must not nag them. We check the balance-autofill AR
     *      and the income-autofill AR independently because the user can
     *      pick two different source ARs for combined autofill.
     *   5. The autofill source has at least one non-zero
     *      `openingReClass` / `closingReClass` somewhere in its templates.
     *   6. The user hasn't already dismissed the dialog for this AR in
     *      the current tab session (sessionStorage-backed flag).
     */
    private maybeShowLegacyReclassesAutofillWarning(): void {
        combineLatest([
            this.annualReportProvider.getActiveAnnualReport$(),
            this.annualReportProvider.getCombinedAutofillFinStatements$(),
            this.annualReportProvider.getAnnualReportForBalanceAutoFill$(),
            this.annualReportProvider.getAnnualReportForIncomeAutoFill$(),
        ])
            .pipe(
                filter(
                    ([ar, source]: [
                        IAnnualReport | null | undefined,
                        IFinStatements[],
                        IAnnualReport | null | undefined,
                        IAnnualReport | null | undefined,
                    ]): boolean => ar != null && Array.isArray(source) && source.length > 0,
                ),
                take(1),
                untilDestroyed(this),
            )
            .subscribe(
                ([ar, source, balanceSourceAr, incomeSourceAr]: [
                    IAnnualReport,
                    IFinStatements[],
                    IAnnualReport | null | undefined,
                    IAnnualReport | null | undefined,
                ]) => {
                    if (!isReclassNewWorld(ar)) return;

                    // REV-XXXXX: skip when the *current* AR has already saved
                    // its grouping & masking step with reclasses. The grouping/masking save
                    // flow always stamps `reclassificationsVersion = 1` on
                    // every save (with or without transactions), so this flag
                    // is a reliable signal that the user has been through the
                    // new reclass workflow at least once. Past that point we
                    // never want to nag them about legacy reclasses on the
                    // autofill source again — they've acknowledged the new
                    // system and any reclass they wanted to carry over has
                    // already been re-entered (or intentionally skipped).
                    if (ar.groupingAndMasking?.reclassificationsVersion === 1 && ar.groupingAndMasking.reclassifications?.length > 0) return;



                    // REV-XXXXX: skip when every loaded autofill source AR is
                    // itself "new" — either created on/after the cutover OR
                    // already using the transactional reclass model. In that
                    // case any reclass value on the source's finStatements is
                    // a derived/runtime artefact of the v1 transactions on
                    // the source AR, not a real legacy reclass on the
                    // account. We treat a missing source AR as new (nothing
                    // to migrate from), so the warning never fires when no
                    // autofill is configured.
                    const isNewSource = (source: IAnnualReport | null | undefined): boolean => {
                        if (source == null) return true;
                        if (source.groupingAndMasking?.reclassificationsVersion === 1 && source.groupingAndMasking.reclassifications?.length > 0) return true;
                        return isReclassNewWorld(source);
                    };
                    if (isNewSource(balanceSourceAr) && isNewSource(incomeSourceAr)) return;

                    if (!hasLegacyReclasses(source)) return;
                    const seenKey = legacyReclassesAutofillWarningSeenKey(ar._id);

                    try {
                        if (sessionStorage.getItem(seenKey) === 'true') return;
                    } catch {
                        // sessionStorage can throw in some embedded contexts; treat as not-yet-seen.
                    }

                    const dialogRef = this.dialog.open<ModalComponent, ModalData, OkCancelDialogActions>(
                        ModalComponent,
                        {
                            disableClose: false,
                            panelClass: 'custom-modalbox',
                            data: {
                                showCloseButton: true,
                                titleIcon: ModalTitleIcons.WARNING,
                                footerButtons: [
                                    {
                                        localizationKey: 'aumico_legacy_reclasses_autofill_warning_ok',
                                        action: OkCancelDialogActions.OK,
                                        buttonColor: 'primary',
                                    },
                                ],
                                titleLocalizationKey: 'aumico_legacy_reclasses_autofill_warning_title',
                                content: {
                                    text: ['aumico_legacy_reclasses_autofill_warning_text'],
                                },
                            },
                        },
                    );

                    dialogRef
                        .afterClosed()
                        .pipe(untilDestroyed(this))
                        .subscribe(() => {
                            try {
                                sessionStorage.setItem(seenKey, 'true');
                            } catch {
                                // best-effort; if storage isn't available, the dialog
                                // will reappear on next visit. Acceptable degradation.
                            }
                        });
                },
            );
    }

    private setPreviousYearClosingIncomeValue(): void {
        this.annualReportProvider
            .getCombinedAutofillFinStatements$()
            .pipe(
                filter(
                    (previousYearFinStatements: IFinStatements[]) =>
                        previousYearFinStatements != null &&
                        previousYearFinStatements[templateConstants.incomeTemplate] != null &&
                        previousYearFinStatements[templateConstants.incomeTemplate].templateAndAccountsMapping
                            .template != null,
                ),
                untilDestroyed(this),
            )
            .subscribe((previousYearFinStatements: IFinStatements[]) => {
                this.previousYearClosingIncomeFromAutofillReport =
                    previousYearFinStatements[
                        templateConstants.incomeTemplate
                    ].templateAndAccountsMapping.template.group.calculatedClosingBalance;
            });
    }

    private checkIfAccountExist(accountToCompare: IAccount, financialStatementArrayIndex: number): number {
        return this.activeFinStatements[financialStatementArrayIndex].templateAndAccountsMapping.accounts.findIndex(
            (account) => accountToCompare.accountNumber === account.accountNumber,
        );
    }
    private getAccountIndex(oldAccount: IAccount, financialStatementArrayIndex: number): number {
        const accountIndex: number = this.checkIfAccountExist(oldAccount, financialStatementArrayIndex);
        return accountIndex;
    }

    onTranslateTemplate(): void {
        let balanceMappedTemplate =
            this.activeFinStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template;
        let incomeMappedTemplate =
            this.activeFinStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template;
        if (balanceMappedTemplate == null || incomeMappedTemplate == null) {
            balanceMappedTemplate = this.balanceFinancialStatementMapping.template;
            incomeMappedTemplate = this.incomeFinancialStatementMapping.template;
        }
        const translationMapper = this.injector.get(TranslationMapper);
        const templatesTranslationRequest = translationMapper.getTemplatesTranslationRequest(
            this.activeAnnualReport,
            balanceMappedTemplate,
            incomeMappedTemplate,
            [this.currentLanguage],
        );

        const templateProvider = this.injector.get(TemplatesProvider);
        templateProvider.dispatchGetTemplatesTargetTranslations(templatesTranslationRequest);
    }

    handlePreviousAnnualProfitResponse(annualReport: IAnnualReport, previousAnnualProfit: number | null): void {
        if (annualReport.isAutomaticTransferOfAnnualResultEnabled === false) {
            return;
        }

        if (annualReport.generalInformation.noPreviousData || (annualReport.generalInformation.balancePreviousYearDate.toString() === annualReport.generalInformation.incomePreviousYearToDate.toString())) {
            //If previous balance sheet date corresponds to the previous income statement period end, then use annual profits from the same current report
            this.shouldUsePreviousAnnualProfitFromCurrentIncomeStatement = true;
            return;
        }

        if (previousAnnualProfit !== null) {
            this.previousAnnualProfitForMissingIncomePeriod = previousAnnualProfit;
        }
    }

    onErrorInProfitFliDetected(errorDetected: boolean): void {
        this.disableProceedButton = errorDetected;
        this.footerExtraButtonActions[FIRST_ELEMENT_INDEX].disabled = errorDetected;
    }

    onAutomaticTransferOfAnnualResultEnabledChange(isEnabled: boolean): void {
        this.activeAnnualReport.isAutomaticTransferOfAnnualResultEnabled = isEnabled;
        this.showSwitchToAutomaticTransferOfAnnualResultBanner = false;
        this.applyAutomaticTransferOfAnnualResultForCurrentAndPreviousValues = isEnabled;

        const previousBalanceSheetData = this.activeAnnualReport.generalInformation.balancePreviousYearDate;
        if (previousBalanceSheetData) {
            this.providerOfAnnualReports.getAnnualProfitOfBalanceAutofillFinstatements$(previousBalanceSheetData).pipe(untilDestroyed(this)).subscribe((previousAnnualProfit) => {
                this.handlePreviousAnnualProfitResponse(this.activeAnnualReport, previousAnnualProfit);
            });

        }
    }

}
